import { render, staticRenderFns } from "./region-zone-layer.vue?vue&type=template&id=e9973a1a&scoped=true"
import script from "./region-zone-layer.vue?vue&type=script&lang=js"
export * from "./region-zone-layer.vue?vue&type=script&lang=js"
import style0 from "./region-zone-layer.vue?vue&type=style&index=0&id=e9973a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9973a1a",
  null
  
)

export default component.exports